import { useEffect, useState } from 'react'
import { Button } from './ui/button'
import { Menu, X, Phone, Mail, MapPin } from 'lucide-react'

const NAV = [
  { href: '#home', label: 'Ana Sayfa' },
  { href: '#services', label: 'Hizmetlerimiz' },
  { href: '#announcements', label: 'Duyurular' },
  { href: '#about', label: 'Hakkımızda' },
  { href: '#contact', label: 'İletişim' },
]

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [active, setActive] = useState('#home')

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 4)
      for (const id of ['home', 'services', 'announcements', 'about', 'contact']) {
        const el = document.getElementById(id)
        if (!el) continue
        const rect = el.getBoundingClientRect()
        if (rect.top <= 100 && rect.bottom >= 100) {
          setActive('#' + id)
          break
        }
      }
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const linkBase =
    'relative inline-block font-medium text-gray-700 hover:text-blue-700 transition-colors'
  const underline =
    "after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-blue-700 after:transition-all hover:after:w-full"
  const activeCls = 'text-blue-700 after:w-full'

  return (
    <header
      className={`sticky top-0 z-50 bg-white ${scrolled ? 'shadow-lg/50 shadow' : 'shadow-sm'}`}
    >
      {/* Top Bar */}
      <div className="bg-blue-900 text-white text-sm">
        <div className="container mx-auto px-4 py-2 flex flex-wrap justify-between items-center gap-2">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1">
              <Phone size={14} />
              <a href="tel:+903128111006" className="hover:underline">
                +90 312 811 10 06
              </a>
            </span>
            <span className="hidden sm:flex items-center gap-1">
              <Mail size={14} />
              <a href="mailto:antrepo@capitaltrans.com.tr" className="hover:underline">
                antrepo@capitaltrans.com.tr
              </a>
            </span>
          </div>
          <div className="flex items-center gap-1">
            <MapPin size={14} />
            <span>Kahramankazan, Ankara</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="text-2xl font-bold text-blue-900">
            Capital<span className="text-orange-500">Trans</span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`${linkBase} ${underline} ${
                  active === item.href ? activeCls : ''
                }`}
                onClick={() => setActive(item.href)}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Right actions */}
          <div className="hidden md:flex items-center gap-3">
            <Button
              as="a"
              href="tel:+905518650150"
              className="bg-gray-100 text-blue-700 hover:bg-blue-100"
            >
              İletişime Geçin
            </Button>
            <Button
              as="a"
              href="mailto:capital@capitaltrans.com.tr"
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              Teklif Al
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-gray-700 hover:text-blue-700"
            onClick={() => setIsMenuOpen((v) => !v)}
            aria-label="Menüyü Aç/Kapat"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMenuOpen && (
          <nav className="md:hidden pt-3 pb-4 border-t border-gray-200">
            <div className="flex flex-col gap-3">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="py-2 px-1 font-medium text-gray-800 hover:text-blue-700"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <div className="flex gap-2 pt-2">
                <Button
                  as="a"
                  href="tel:+905518650150"
                  className="bg-gray-100 text-blue-700 hover:bg-blue-100 w-1/2"
                >
                  Ara
                </Button>
                <Button
                  as="a"
                  href="mailto:capital@capitaltrans.com.tr"
                  className="bg-orange-500 hover:bg-orange-600 text-white w-1/2"
                >
                  Teklif Al
                </Button>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}
